import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ErrorBox from '@components/common/ErrorBox';
import DwFormField from '@ui/formfield/DwFormField';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import { Form } from 'react-final-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import { getRandomUUID } from '@common/utils/stringUtils';
import LoginContentAssetInfoMessage from './LoginContentAssetInfoMessage';
import analytics from '@stone/utils/analytics';
import Button from '@stone/ui/button/Button';
const focusOnError = createDecorator(); // must be outside the component
const LoginEmailForm = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = useState([]);
    const [formdef, setFormdef] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [initialValues, setInitialValues] = useState();
    const [randomUUID, setRandomUUID] = useState();
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).loginButton;
    useEffect(() => {
        let val = {};
        api.getForm('email', val).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
        setRandomUUID(getRandomUUID());
    }, []);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'email');
    };
    const onSubmitEmail = async (values) => {
        setErrors([]);
        setIsSubmitting(true);
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        //start login or register flow
        analytics.loginOrRegister('email');
        api
            .checkLogin(values)
            .then((data) => {
            setIsSubmitting(false);
            props.setDoubleOptIn && props.setDoubleOptIn(data.clothingOptIn);
            if (data.success) {
                props.setLoginEmail(values.email);
                // props.isLoginOrRegisterPage && analytics.loginOrRegister('');
                // gestione clothing
                if (data.exist && data.hasAvailableLoginMethods) {
                    // esiste account con questa mail
                    props.setLoginMethods(data.loginMethods);
                    //check account creato in Store
                    if (data.isCreatedInStore && !data.hasChangedPassword) {
                        if (data.hasSentCompleteProfileEmail) {
                            props.setLoginStep('registeredInStore');
                        }
                        else {
                            props.setLoginStep('registeredInStoreSendEmail');
                        }
                    }
                    else {
                        // Se l'ultimo metodo utilizzato è l'email || su clothing l'utente è registrato con una mail
                        if (data.loginMethods[0].ID == 'email') {
                            props.setLoginStep('password');
                        }
                        else {
                            props.setLoginStep('social-login');
                        }
                    }
                }
                else {
                    // NON esiste account con questa mail
                    props.setLoginStep('register');
                }
            }
            if (data.error) {
                setErrors([data.errorMessage]);
            }
        })
            .catch((e) => {
            setErrors([e]);
            setIsSubmitting(false);
        });
    };
    const widhHeading = () => {
        if (props.hideHeading)
            return React.createElement(React.Fragment, null);
        const _text = t('login.subtitle');
        if (!props.useHeading)
            return React.createElement("p", null, _text);
        return props.useHeading === 'h2' ? React.createElement("h2", null, _text) : React.createElement("h3", null, _text);
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(LoginContentAssetInfoMessage, { contentAssetID: "login-message", customClasses: [!props.useHeading ? 'mt-20' : 'mb-20'] }),
        widhHeading(),
        React.createElement(Form, { onSubmit: onSubmitEmail, initialValues: initialValues, decorators: [focusOnError], validate: (values) => validate(values), render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { className: "formfields" },
                    React.createElement(DwFormField, { def: formdef, name: "email", type: "email", idSuffix: randomUUID, autocomplete: "email" }),
                    React.createElement(ErrorBox, { errors: errors })),
                showRecaptcha && createPortal(React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }), document.body),
                React.createElement(Button, { type: "submit", disabled: isSubmitting, className: 'full button-login-cta', cls: ['button--primary'] }, t('login.loginregistertomymoncler')))) })));
};
export default LoginEmailForm;
